export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-print-3cabf3a936b8a2a5fcebfbcda65428f1.svg";